import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import React, {PropsWithChildren} from "react";

import theme from "./index";

const ThemeProvider = ({ children }:PropsWithChildren) => (
  <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
);

export default ThemeProvider;
